import {base, PeriodTypes, SystemKey} from './constants';
import {mapState, mapActions, mapGetters} from 'vuex';
import prettyBytes from 'pretty-bytes';
export default {

    data:() => ({
        fileLimit: 1,
        fileSizeLimit: 5000000,
        dataOptions: {
            uid: 0
        },
    }),
    computed:{
        action() {
            return `${base}api/pebooking/upload`
        },
        ...mapGetters('auth', ['token']),
        uploadHeaders() {
            return {
                'authorization': `Bearer ${this.token}`,
                'systemKey': SystemKey
            };
        },
    },
    methods:{
        setFileLimit(limit){
            this.fileLimit = Math.max(0, limit);
        },

        setSizeLimit(limit){
            this.fileSizeLimit = Math.max(0, limit);
        },

        ...mapActions({
            removeFile: 'removeFileAction',
            download: 'downloadFileAction'
        }),

        onExceedLimit(files) {
            this.$message.warning(`只能上傳 ${this.fileLimit} 檔案`);
        },

        onUploadError() {
            this.$message.error(`發生錯誤，請重新上傳!`);
        },

        beforeUpload(file) {
            if (file.size > this.fileSizeLimit) {
                this.$message.warning(`檔案超過 ${prettyBytes(this.fileSizeLimit)}`);
                return false;
            }
            this.dataOptions.uid = file.uid;
            return true;
        },


        async beforeRemove({response}) {
            if(response){
                await this.removeFile({key: response.key});
            }

        },
    },
}